import { TranslateService } from '@ngx-translate/core';
import { AlertQueue } from '@app/core/models/alert.model';
import { Injectable } from '@angular/core';
import Swal, { SweetAlertOptions } from 'sweetalert2';
import { sw2Config } from '@app/configs/properties.config';

@Injectable({
  providedIn: 'root',
})
export class AlertService {

  constructor(
    private translate:TranslateService
  ){}
  swal = Swal.mixin({ ...sw2Config });

  

  archive(callBackFunction:Function, toast: boolean = false ):Promise<any>{
      return this.swal.fire(<SweetAlertOptions>{
        type: 'question',
        background:'primary',
        titleText: 'คุณต้องการที่จะจัดเก็บไฟล์',
        showCloseButton: false,
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonColor:'#1c8cf6',
        cancelButtonColor:'#ff2a2a',
        toast: toast,
      }).then((result) => {
        if(result.value){
          callBackFunction();
        }
      });
  }

  delete(callBackFunction:Function, toast: boolean = false ):Promise<any>{
    return this.swal.fire(<SweetAlertOptions>{
      type: 'warning',
      titleText: this.translate.instant('CONFIRM.Do you want to delete this setting'),
      showCloseButton: false,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor:'#1c8cf6',
      cancelButtonColor:'#ff2a2a',
      toast: toast,
    }).then((result) => {
      if(result.value){
        callBackFunction();
      }
    });
}

successUpsert(callBackFunction:Function,toast: boolean = false,message:string): Promise<any> {
  return this.swal.fire(<SweetAlertOptions>{
    type: 'success',
    titleText: this.translate.instant('Success'),
    text: message,
    showCloseButton: true,
    showCancelButton: false,
    showConfirmButton: false,
    toast: toast,
  }).then((result) =>{
    callBackFunction();
  });
}

  success(message: string, toast: boolean = false): Promise<any> {
    return this.swal.fire(<SweetAlertOptions>{
      type: 'success',
      titleText: this.translate.instant('Success'),
      text: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      toast: toast,
    });
  }

  successTH(message: string, toast: boolean = false): Promise<any> {
    return this.swal.fire(<SweetAlertOptions>{
      type: 'success',
      titleText: this.translate.instant('Success'),
      text: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      toast: toast,
    });
  }

  error(message: string): Promise<any> {
    return this.swal.fire(<SweetAlertOptions>{
      type: 'error',
      titleText: this.translate.instant('Error'),
      text: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }

  errorBilling(message: string): Promise<any> {
    return this.swal.fire(<SweetAlertOptions>{
      type: 'error',
      titleText: this.translate.instant('Error'),
      html: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }



  warn(message: string): Promise<any> {
    return this.swal.fire(<SweetAlertOptions>{
      type: 'warning',
      titleText: this.translate.instant('Warning'),
      text: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }

  warningKYC(message: string,titleText: string): Promise<any> {
    return this.swal.fire(<SweetAlertOptions>{
      type: 'warning',
      titleText: titleText,
      text: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }

  info(message: string): Promise<any> {
    return this.swal.fire(<SweetAlertOptions>{
      type: 'info',
      titleText: this.translate.instant('Info'),
      text: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }

  confirm(
    message: string,
    titleText: string = this.translate.instant('CONFIRM.This operation cannot be undone')
  ): Promise<any> {
    return this.swal.fire(<SweetAlertOptions>{
      type: 'warning',
      titleText: titleText,
      text: message,
      confirmButtonText : this.translate.instant('Confirm'),
      cancelButtonText : this.translate.instant('CANCEL'),
    });
  }

  queue(alerts: AlertQueue[]): Promise<any> {
    return Swal.mixin({
      ...sw2Config,
      confirmButtonText: 'OK',
      showCancelButton: false,
      showCloseButton: false,
    }).queue(alerts);
  }

  successAutoClose(message: string): Promise<any> {
    return Swal.fire(<SweetAlertOptions>{
      type: 'success',
      titleText: this.translate.instant('Success'),
      text: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false, 
      timer: 3000
    });
  }

  errorAutoClose(message: string): Promise<any> {
    return this.swal.fire(<SweetAlertOptions>{
      type: 'error',
      titleText: this.translate.instant('Error'),
      text: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      timer: 3000
    });
  }

  warningKYCAutoClose(message: string,titleText: string): Promise<any> {
    return this.swal.fire(<SweetAlertOptions>{
      type: 'warning',
      titleText: titleText,
      text: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      timer: 3000
    });
  }

  warningWithConfirm(
    message: string
  ): Promise<any> {
    return this.swal.fire(<SweetAlertOptions>{
      type: 'warning',
      titleText: this.translate.instant('Warning'),
      text: message,
      confirmButtonText : this.translate.instant('Yes'),
      cancelButtonText : this.translate.instant('No'),
      focusCancel: true,
      showCancelButton: true, 
      confirmButtonColor: "#dc3545", 

    });
  }
}
